import { useEffect } from "react";

/**
 * Lightweight document title / meta description without adding a SEO library.
 */
export function useDocumentMeta({ title, description } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const prevDesc = meta.getAttribute("content");
    if (description) meta.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (created) meta.remove();
      else if (prevDesc != null) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
